module.exports = __webpack_public_path__ + "static/img/cont58_04.324807e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont58_04.jpg
// module id = NzBh
// module chunks = 0